import type { ReactNode } from 'react';

export const symbol_bedroom_baby: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M481.62-219Q557-219 627-243.5T754-316q11-9.26 12-22.63T757-360q-10-8-22-8t-23 8q-7 5-13.5 9t-13.5 8l-41-76v-103h31q6.8 0 11.9-5.14 5.1-5.15 5.1-12 0-6.86-5.1-11.86-5.1-5-11.9-5H451l-68-117q-3.71-6.75-10.77-10.88Q365.17-688 357-688h-87q-5 0-7 5.5t3 8.5l16 11-53 56q-7 7.14-7 16.5t7 16.5l4 4q6.19 6.22 14.6 7.11Q256-562 264-567l52-36v184l-40 76q-8-4-15.5-9T246-362q-10-8-22-7t-20.94 8.53Q193-352 193.5-339.12T204-318q59 49 130.08 74 71.07 25 147.54 25Zm.88-59q-40.5 0-82.5-8.5T316-318l46-76q31 12 60.18 18 29.17 6 57.82 6 29 0 58-6t60-18l46 76q-42 22-81.5 31t-80 9ZM140-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h680q24 0 42 18t18 42v680q0 24-18 42t-42 18H140Zm0-60h680v-680H140v680Zm0 0v-680 680Z"
		/>
	</svg>
);
